import { mappingAggregateProperty } from './mappingAggregateProperty';

export default mappingAggregateProperty;
